var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.floor.$style,{tag:"component",attrs:{"floor":_vm.floor,"home":_vm.home},on:{"call":function (e) { return _vm.$emit('call', e); },"jump":_vm.onJumpToGoodsDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }